import React from "react"
import { makeStyles } from "@material-ui/styles"
import { Box, Collapse, Typography, Button, IconButton, Tooltip } from "@material-ui/core"
import { RowBox } from "../Boxes/RowBox"
import { Icon } from "../Icon/Icon"
import { LoadingSkeleton } from "../LoadingSkeleton/LoadingSkeleton"
import { RequirePermissions } from "../Permissions/RequirePermissions"

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: "20px",
    marginLeft: theme.spacing(1)
  },
  subNavigation: {
    ...theme.cards.navigationCard,
    position: "sticky",
    padding: 0,
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      paddingTop: 0
    }
  },
  titleButton: {
    color: theme.palette.primary.main,
    cursor: "pointer",
    borderRadius: theme.radius(0.5),
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    fontWeight: 600,
    height: "fit-content",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.primary.dark
    }
  },
  titleIconButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    transition: "0.2s all",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark
    },
    "&:focus": {
      backgroundColor: theme.palette.primary.dark
    }
  }
}))

const SubNavigation = ({
  title,
  titleButtonIcon,
  titleButtonText,
  titleButtonTooltip,
  titleButtonOnClick,
  permissionRequired = "",
  children,
  className,
  titleClassName,
  mr = 0,
  mb = 1,
  loading = false,
  noPadding = false,
  ...rest
}) => {
  const classes = useStyles({ noPadding })

  const renderTitleButton = () => {
    if (!titleButtonText) {
      if (titleButtonTooltip) {
        return (
          <Tooltip title={titleButtonTooltip}>
            <IconButton size="small" color="primary" className={classes.titleIconButton} onClick={titleButtonOnClick}>
              <Icon fontSize="small" name={titleButtonIcon} />
            </IconButton>
          </Tooltip>
        )
      }
      return (
        <IconButton size="small" color="primary" className={classes.titleIconButton} onClick={titleButtonOnClick}>
          <Icon fontSize="small" name={titleButtonIcon} />
        </IconButton>
      )
    }

    return (
      <Button
        onClick={titleButtonOnClick}
        startIcon={<Icon name={titleButtonIcon} />}
        variant="text"
        color="primary"
        size="small"
      >
        {titleButtonText}
      </Button>
    )
  }

  return (
    <Box className={`${classes.subNavigation} ${className}`} mr={mr} mb={mb} {...rest}>
      <RowBox justifyContent="space-between" alignItems="center" justifyItems="center" mb={0.5}>
        {!!title && (
          <Typography variant="h3" className={`${classes.title} ${titleClassName}`}>
            {title}
          </Typography>
        )}

        {(titleButtonIcon || titleButtonText) && (
          <>
            {permissionRequired && (
              <RequirePermissions requires={permissionRequired}>{renderTitleButton()}</RequirePermissions>
            )}

            {!permissionRequired && renderTitleButton()}
          </>
        )}
      </RowBox>
      {loading && <LoadingSkeleton px={1} py={1} quantity={4} height={32} />}
      <Collapse in={!loading}>{!loading && children}</Collapse>
    </Box>
  )
}

export { SubNavigation }
